// @flow

import React from "react";
import { localize } from "redux-i18n";
import { Row, Col } from "@components";

type OwnProps = $Exact<{
  totalDepartments: number,
  created: number,
  deleted: number,
  moved: number,
  renamed: number,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
}>;

export const Stats = (props: Props) => (
  <Row className="pl-3 flex-fill">
    <Col md="3" className="border-top border-light-grey pt-2">
      <span className="font-weight-bold text-grey">{props.t("TOTAL_DEPARTMENTS")}</span>
      <h2 className="font-weight-bold">{props.totalDepartments}</h2>
    </Col>
    <Col md="3" className="border-top border-light-grey pt-2">
      <span className="font-weight-bold text-grey">{props.t("CHANGES")}</span>
      <h2 className="font-weight-bold">
        {props.created + props.deleted + props.moved + props.renamed}
      </h2>
    </Col>
    <Col md="6">
      <Row>
        <Col md="6" className="border-top border-light-grey pt-2">
          <span>{props.t("CREATED")}</span>
          <p>{props.created}</p>
        </Col>
        <Col md="6" className="border-top border-light-grey pt-2">
          <span>{props.t("DELETED")}</span>
          <p>{props.deleted}</p>
        </Col>
      </Row>
      <Row>
        <Col md="6" className="border-top border-light-grey pt-2">
          <span>{props.t("MOVED")}</span>
          <p>{props.moved}</p>
        </Col>
        <Col md="6" className="border-top border-light-grey pt-2">
          <span>{props.t("RENAMED")}</span>
          <p>{props.renamed}</p>
        </Col>
      </Row>
    </Col>
  </Row>
);

export default localize()(Stats);
